<div
  *ngIf="activeTariff$ | async as activeTariff"
  class="tariff-block"
  data-qa-block="active-tariff"
>
  <div class="tariff-block_title" data-qa="block-title">
    {{ 'tariffs.active.subscribe' | translate }}
  </div>
  <tax-vertical-tariff-list
    class="tariff-list"
    [activeTariff]="activeTariff"
    [tariffs]="[activeTariff]"
    (emitSelectedTariff)="selectTariff($event)"
  ></tax-vertical-tariff-list>
</div>
<div
  *ngIf="availableTariffs$ | async | uniqueTariffs as tariffs"
  class="tariff-block"
  data-qa-block="available-tariffs"
>
  <div class="tariff-block_title" data-qa="block-title">
    {{ 'tariffs.available.subscribe' | translate }}
  </div>
  <tax-vertical-tariff-list
    class="tariff-list"
    [tariffs]="tariffs"
    (emitSelectedTariff)="selectTariff($event)"
  ></tax-vertical-tariff-list>
</div>
